<template>
  <!-- <DiceRollerPopover :visible="showDiceRoller" @remove-inspiration="removeInspiration" @close="showDiceRoller = false" /> -->

  <!-- <Teleport to="#navbarEnd">
    <div class="headerButtons">
      <div class="buttons">
        <button class="button is-primary">Roll Dice</button>
      </div>
    </div>
  </Teleport> -->

  <div v-if="hostState.status === JOINED" data-view="room">
    <div class="columns is-variable is-6">
      <div class="column is-one-quarter">
        <Card>
          <div class="block">
            <h2 class="characterTitle title is-6">Characters</h2>
          </div>
          <hr />
          <div class="block is-flex is-flex-direction-column">
            <div v-for="character in hostState.characters" :key="character.id" class="character">
              <div class="level" style="margin-bottom:0.25rem">
                <div class="level-item level-left">
                  <p class="title is-5">{{ character.name }}</p>
                </div>
              </div>
              <p class="subtitle is-6">{{ allRaces[character.race].name }} {{ allClasses[character.className].name }} ({{ allDifficulties[character.difficulty].name }})</p>
            </div>
          </div>
        </Card>
      </div>
      <div class="column is-one-quarter">
        <Card>
          <div class="block">
            <div class="level">
              <div class="level-item level-left">
                <h2 class="characterTitle title is-6">Rolls</h2>
              </div>
              <div class="level-item level-right">
                <div class="buttons has-addons">
                  <button class="button is-small" @click="clearRolls">Clear Rolls</button>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <table class="table is-fullwidth is-narrow" style="font-size: 90%">
            <tbody>
              <tr v-for="(roll, i) in hostState.rolls" :key="i">
                <th>{{ hostState.characters.find((c) => c.id === roll.id).name }}</th>
                <td style="text-align:right">{{ roll.outcome.outcome }}</td>
              </tr>
            </tbody>
          </table>
        </Card>
      </div>
      <div class="column is-one-quarter">
        <Card>
          <div class="block">
            <div class="level">
              <div class="level-item level-left">
                <h2 class="characterTitle title is-6">Combat</h2>
              </div>
              <div class="level-item level-right">
                <div class="buttons has-addons">
                  <button class="button is-small" @click="resetCombatOrder">Reset</button>
                  <button class="button is-small" @click="openModal('addNpc')">Add NPC</button>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="block" id="combatOrder" ref="combatOrderEl">
            <div v-for="item in combatOrder" :key="item.character.id" class="character isTracker" :data-id="item.character.id">
              <div class="level">
                <div class="level-item level-left">
                  <span class="icon handle" data-icon="&#xe25d;" />&nbsp;&nbsp;
                  <a v-if="item.isNpc" class="link" :href="`https://roll20.net/compendium/dnd5e/${item.character.name}`" target="_blank">
                    <strong>{{ item.character.name }}</strong>
                  </a>
                  <RouterLink v-else class="link" :to="{ name: 'viewCharacter', params: { id: item.character.id } }">
                    <strong>{{ item.character.name }}</strong>
                  </RouterLink>
                </div>
                <div class="level-item level-left is-justify-content-flex-end">
                  <small class="level">
                    <span v-if="typeof item.character.speed === 'number'" class="level-item">{{ item.character.speed }} ft.</span>
                    <span v-if="typeof item.character.armor === 'number'" class="level-item">{{ item.character.armor }} AC</span>
                    <a v-if="item.isNpc" class="level-item" @click="openModal('modifyHealth', item.character)">{{ item.character.health }} / {{ item.character.maxHealth }}</a>
                    <span v-else><strong>{{ item.character.health }}</strong></span>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <div class="column is-one-quarter">
        <Card>
          <div class="block">
            <div class="level">
              <div class="level-item level-left">
                <h2 class="characterTitle title is-6">Notes</h2>
              </div>
              <div class="level-item level-right">
                <div class="buttons has-addons">
                  <button class="button is-small" @click="openModal('editNotes')">Edit Notes</button>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div class="block roomNotes">{{ hostState.notes.trim() }}</div>
        </Card>
      </div>
    </div>
  </div>

  <Teleport to="#modalContent">
    <Modal name="addNpc">
      <ModalCard>
        <template v-slot:title>Add NPC</template>
        
        <div class="field">
          <label class="label">Name</label>
          <div class="control">
            <input v-model="addNpcForm.name" class="input" type="text">
          </div>
        </div>

        <div class="field">
          <label class="label">Speed / Armor / Health</label>
          <div class="field is-grouped">
            <div class="control">
              <input v-model.number="addNpcForm.speed" class="input" type="number" placeholder="Speed" :min="0" :max="1000">
            </div>
            <div class="control">
              <input v-model.number="addNpcForm.armor" class="input" type="number" placeholder="Armor" :min="0" :max="1000">
            </div>
            <div class="control">
              <input v-model.number="addNpcForm.maxHealth" class="input" type="number" placeholder="Health" :min="0" :max="1000">
            </div>
          </div>
        </div>

        <template v-slot:buttons>
          <div class="button" @click="clearNpcForm">
            Reset
          </div>
          <div class="button is-primary" :disabled="!addNpcForm.name ? true : null" @click="doAddNpc">
            Add NPC
          </div>
        </template>
        </ModalCard>
    </Modal>

    <Modal name="editNotes">
      <ModalCard>
        <template v-slot:title>Edit Notes</template>
        
        <div class="field">
          <div class="control">
            <textarea class="textarea" rows="10" v-model="hostState.notes" />
          </div>
        </div>
      </ModalCard>
    </Modal>

    <Modal name="modifyHealth">
      <template v-slot:default="{ options }">
        <ModalCard>
          <template v-slot:title>Modify Health</template>
          
          <div class="field has-addons has-addons-centered">
            <div class="control">
              <input ref="modifyHealthAmountEl" class="input isShort" type="number" placeholder="0" :value="healthValue" :min="-options.maxHealth" :max="options.maxHealth">
            </div>
            <div class="control">
              <div class="button is-primary" @click="addSubtractHealth">
                Add/Subtract
              </div>
            </div>
            <div v-if="options.value === undefined" class="control">
              <div class="button is-text" @click="setHealth">
                Set
              </div>
            </div>
          </div>
        </ModalCard>
      </template>
    </Modal>
  </Teleport>
</template>

<script>
/* eslint-disable */
import { defineComponent, computed, ref, reactive, onMounted, onUnmounted, watch, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import sortable from 'html5sortable/dist/html5sortable.es.js'

import { useHost, JOINED } from '@/hooks/room'
import useModal from '@/hooks/useModal'
import useToast from '@/hooks/useToast'

import Card from '@/components/Card'
import Modal from '@/components/Modal'
import ModalCard from '@/components/ModalCard'

// Data
// import allActions from '@/data/actions'
import allClasses from '@/data/classes'
// import allFeatures from '@/data/features'
import allRaces from '@/data/races'
// import allSkills from '@/data/skills'
// import allWeapons from '@/data/weapons'
import allDifficulties from '@/data/difficulties'
// import allEquipment from '@/data/equipment'
// import allSpells from '@/data/spells'
// import allBonuses from '@/data/bonuses'

export default defineComponent({
  components: {
    Card,
    ModalCard,
    Modal
  },

  setup () {
    const router = useRouter()
    const toast = useToast()
    const { openModal, closeModal, currentModal } = useModal()
    const { 
      state: hostState, 
      on: addHostEventHandler,
      off: removeHostEventHandler,
      addNpc, 
      clearRolls, 
      resetCombatOrder, 
      updateCombatOrder,
      updateNpc
    } = useHost()

    if (hostState.status !== JOINED) {
      router.replace({ name: 'home' })
    }

    const combatOrder = computed(() => hostState.combatOrder.map((id) => {
      const character = hostState.characters.find((c) => c.id === id) || hostState.npcs.find((n) => n.id === id)
      const isNpc = !!hostState.npcs.find((n) => n.id === id)
      return {
        character,
        isNpc 
      }
    }))
    watch(combatOrder, () => {
      nextTick(() => {
        setTimeout(() => sortable('#combatOrder'), 100)
      })
    })

    const addNpcForm = reactive({
      name: '',
      maxHealth: 1,
      armor: 1,
      speed: 30
    })
    const doAddNpc = () => {
      addNpc({
        name: addNpcForm.name,
        health: addNpcForm.maxHealth,
        maxHealth: addNpcForm.maxHealth,
        armor: addNpcForm.armor,
        speed: addNpcForm.speed
      })
      closeModal()
    }
    const clearNpcForm = () => {
      addNpcForm.name = ''
      addNpcForm.maxHealth = 1
      addNpcForm.armor = 1
      addNpcForm.speed = 30
    }

    const modifyHealthAmountEl = ref(null)
    const healthValue = ref(0)

    const clampHealth = (amount, npc) => Math.min(Math.max(amount, 0), npc.maxHealth)
    const addSubtractHealth = () => {
      const amount = Number(modifyHealthAmountEl.value.value) || 0
      const npc = currentModal.value.options
      npc.health = clampHealth(npc.health + amount, npc)
      updateNpc(npc)
      closeModal()
      healthValue.value = 0
    }
    const setHealth = () => {
      const amount = Number(modifyHealthAmountEl.value.value) || 0
      const npc = currentModal.value.options
      npc.health = clampHealth(amount, npc)
      updateNpc(npc)
      closeModal()
      healthValue.value = 0
    }

    const roomClosedHandler = () => {
      router.push({ name: 'home' })
    }

    let combatOrderEl = ref(null)
    let combatOrderList

    onMounted(() => {
      addHostEventHandler('error', roomClosedHandler)
      addHostEventHandler('disconnect', roomClosedHandler)
      addHostEventHandler('roomClosed', roomClosedHandler)

      combatOrderList = sortable('#combatOrder', {
        handle: '.handle'
      })[0]
      if (!combatOrderList) return
      combatOrderList.addEventListener('sortupdate', () => {
        const el = combatOrderEl.value
        const newOrder = Array.from(el.querySelectorAll('[data-id]')).map((el) => el.getAttribute('data-id'))
        updateCombatOrder(newOrder)
        console.log('engaging sortable', newOrder)
      })
    })

    onUnmounted(() => {
      removeHostEventHandler(roomClosedHandler)
    })

    return {
      openModal,
      hostState,
      allRaces,
      allClasses,
      allDifficulties,
      combatOrder,
      combatOrderEl,
      JOINED,
      clearRolls,
      resetCombatOrder,
      doAddNpc,
      addNpcForm,
      clearNpcForm,
      modifyHealthAmountEl,
      addSubtractHealth,
      setHealth,
      healthValue
    }
  }
})
</script>

<style lang="sass" scoped>
.headerButtons
  display: flex
  .buttons
    margin: 0 0.25rem !important
    .button
      margin-bottom: 0 !important

.character
  cursor: pointer
  margin: 0
  padding: 1em 0
  &:not(:last-child)
    margin: 0
    padding: 1em 0
    border-bottom: solid 1px #dbdbdb
  &:first-child
    padding-top: 0
  &:last-child
    padding-bottom: 0
  &.isTracker
    cursor: default
    small
      font-family: 'Roboto'
    &.sortable-dragging
      border: none
      padding: 0.5em

.handle
  cursor: move
  color: #dbdbdb

.roomNotes
  white-space: pre-wrap
</style>
